import { BronzorTemplate } from './bronzor';
import { OnyxATSTemplate } from './onyx';

export default {
  Bronzor: BronzorTemplate,
  Onyx: OnyxATSTemplate,
};
